import React, { useEffect, useState } from "react"
import { useNavigate, Link } from "react-router-dom";
import WOW from "wowjs";
import "animate.css";
import Map from '../images/graph-image.png'
import { REGISTRATION_ABI, REGISTRATION_ADDRESS, MATRIX_CONTRACT, MATRIX_ABI } from '../constants/contract'
import useWalletConnect from "../hooks/useWalletConnect";
import { Contract, isAddress, formatUnits } from "ethers";
import contractErrorHandler from "../hooks/contractErrorHandler";
import { useUser } from "../context/UserContext";
import waves from '../images/waves.png'
import InnerHeader from '../components/InnerHeader'
import logo from '../images/logo.png'
import ClipboardJS from 'clipboard'

const Dashboard = () => {

    const navigate = useNavigate();
    const { setUser, userData } = useUser();

    const [checkID, setCheckID] = useState('');

    useEffect(() => {
        const clipboard = new ClipboardJS('.copy-btn');
        clipboard.on('success', (e) => {

            alert('Copied to clipboard!');
        });
        clipboard.on('error', (e) => {
            alert('Failed to copy');
        });

        return () => {
            clipboard.destroy();
        };
    }, []);


    const {
        account,
        connectBrowserWallet,
        connectWalletConnect,
        disconnectWallet,
        connectionType,
        loading,
        signer
    } = useWalletConnect();


    const refresh = async () => {
        try {
            if (!signer) return alert("Connect your wallet first");
            setIsLoading(true)
            const contract = new Contract(MATRIX_CONTRACT, MATRIX_ABI, signer);

            const regContract = new Contract(REGISTRATION_ADDRESS, REGISTRATION_ABI, signer);

            const checkReg = await regContract.getUserDetails(account.address)

            if (checkReg.registered) {
                //const userRec=await contract.getUserDetails(account.address)

                const result = await contract.getAllUserRecord(account?.address);
                const referrals = await regContract.getDirectReferrals(account.address)

                const totalTeam = await regContract.getReferralCounts(account.address);

                const formatted = {
                    user: result?.[0],
                    income: result?.[1],
                    //earnings: result[2], */
                    userRecord: checkReg,
                    refs: referrals.length,
                    team: totalTeam[1]
                };
                // Save to the context
                setUser(formatted);


            }
            else {
                //setError('You are not yet registered')
            }
            setIsLoading(false);
        } catch (err) {
            console.error("Error fetching user data:", err);
            // setError(parseError(err))
        }
    };



    if (!userData) navigate('/register')

    const [error, setError] = useState('');
    const [checkRecord, setCheckRecord] = useState('');

    function trimAddress(address, length = 4) {
        if (!address) return '';
        return `${address.slice(0, 2 + length)}...${address.slice(-length)}`;
    }

    useEffect(() => {
        new WOW.WOW().init();
    }, []);

    const { parseError } = contractErrorHandler();

    const formatEth = (amount) => {
        if (amount != null) {
            return formatUnits(amount, 18);

        } else {
            return 0;
        }
    }



    const handleChange = (event) => {
        setCheckID(event.target.value);
    };

    const checkUpline = async () => {
        try {
            if (!signer) return alert("Connect your wallet first");
            setIsLoading(true)
            // const contract = new Contract(MATRIX_CONTRACT, MATRIX_ABI, signer);

            if (checkID == '') {
                alert('Enter User ID')
                return;
            }

            const regContract = new Contract(REGISTRATION_ADDRESS, REGISTRATION_ABI, signer);
            const getAddress = await regContract.getReferrerByUserId(checkID)

            const userDetails = await regContract.getUserDetails(getAddress)

            const getRefID = await regContract.getUserDetails(userDetails?.[0])

            setCheckRecord('Upline ID: ' + getRefID[3] + '<br> Upline Address: ' + userDetails?.[0])

            setIsLoading(false);
        } catch (err) {
            setIsLoading(false)
            alert(parseError(err))

        }
    };

    const textToCopy = 'https://markman.pro/register?ref=' + userData?.userRecord?.[3];

    const [isLoading, setIsLoading] = useState(false);


    return (
        <>
            <InnerHeader />

            <section className="bg-secondary-100" >

                <div className="h-fit py-10  px-4 md:px-6">

                    <div className="pt-20" >

                        <div className="grid grid-cols-12" >

                            <div className="col-span-12 md:col-span-1"></div>

                            {/*     <div className="col-span-12 md:col-span-2 lg:col-span-2 px-3">

                                <div className="bg-secondary-200 p-3 rounded-xl mb-3 pl-5 text-gray text-xs">
                                    Dashboard <i className="fa fa-arrow-right"></i>
                                </div>

                                <div className="bg-secondary-200 p-3 rounded-xl mb-3 pl-5 text-gray text-xs">
                                    Dashboard <i className="fa fa-arrow-right"></i>
                                </div>

                            </div>
                             */}
                            <div className="col-span-12 md:col-span-10">

                                <div className="grid grid-cols-12 font-pregular" >



                                    <div className="col-span-12 md:col-span-6 lg:col-span-4 text-white px-3 wow animate__animated animate__fadeInUp mb-5">
                                        <div className="bg-secondary-200 border-t border-secondary  p-5 py-5 rounded-3xl shadow-2xl flex items-center">
                                            <div className="glow-circle rounded-full border-white text-base h-[60px] w-[60px] justify-center flex items-center">
                                                <i className="fa fa-user text-secondary-100 fa-2x"></i>
                                            </div>

                                            <div className="ml-8 text-xs">
                                                <div className="mb-2"><span className="text-xs font-psemibold mt-5 text-secondary">USER ID:</span> {userData?.userRecord[3]}
                                                    {!isLoading ? (
                                                        <button className="text-xs small bg-primary text-black px-3 ml-3 rounded-lg" onClick={refresh}><i className="fa fa-undo"></i> Refresh</button>
                                                    ) :
                                                        (<button className="text-xs small bg-primary text-black px-3 ml-3 rounded-lg"  ><i className="fa fa-spinner fa-spin"></i> </button>
                                                        )
                                                    }

                                                </div>
                                                <div className="mb-2"><span className="text-xs font-psemibold mt-5 text-secondary">WALLET:</span> {trimAddress(account?.address)}
                                                </div>
                                                <div className="mb-2"><span className="text-xs font-psemibold mt-5 text-secondary">ACTIVE SLOT:</span>  {userData?.user?.[0] == 0 ? `None` : 'Level ' + userData?.user?.[0]}
                                                
                                                </div>

                                            </div>
                                        </div>
                                    </div>




                                    <div className="col-span-12 md:col-span-6 lg:col-span-4 text-white px-3 wow animate__animated animate__fadeInUp mb-5" data--wow-delay="0.3s" >
                                        <div className="bg-secondary-200 border-t border-secondary  p-5 py-7 rounded-3xl shadow-2xl flex items-center">
                                            <div className="glow-circle rounded-full border-white text-base h-[60px] w-[86px] justify-center flex items-center">
                                                <i className="fa fa-link text-secondary-100 fa-2x"></i>
                                            </div>

                                            <div className="ml-8 text-xs w-[100%]">
                                                <div className="mb-2"><span className="text-xs font-psemibold mt-5 text-secondary">Refferal Link:</span>
                                                </div>
                                                <div className="flex w-100">
                                                    <input type="text" readonly value={`https://markman.pro/register?ref=${userData?.userRecord[3]}`} className="text-xs border w-[70%] rounded px-3 py-2 bg-secondary-200 text-gray-100" />
                                                    <button type="button" className="btn bg-secondary-200 border border px-3 py-2 copy-btn" data-clipboard-text={textToCopy}><i className="fa fa-copy"></i></button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>




                                    <div className="col-span-12 md:col-span-6 lg:col-span-4 text-white px-3 wow animate__animated animate__fadeInUp mb-5" data--wow-delay="0.3s" >
                                        <div className="bg-secondary-200 border-t border-secondary  p-5 py-7 rounded-3xl shadow-2xl flex items-center">

                                            <div className="ml-8 text-xs w-[100%]">
                                                <div className="mb-2"><span className="text-xs font-psemibold mt-5 text-secondary text-center">Upline Check</span>
                                                </div>
                                                <div className="flex w-100">
                                                    <input type="text" placeholder="Enter User ID" className="text-xs border w-[80%] rounded px-3 py-2 bg-secondary-200 text-gray-100" value={checkID} onChange={handleChange} />
                                                    {!isLoading ? (<button type="button" className="btn bg-primary text-black border border px-3 py-2" onClick={checkUpline}><i className="fa fa-search"></i></button>)
                                                        : (<button type="button" className="btn bg-primary text-black border border px-3 py-2"><i className="fa fa-spin fa-spinner"></i></button>)
                                                    }
                                                </div>
                                                {checkRecord && (<div className="mt-3 text-green-200 font-pmedium" dangerouslySetInnerHTML={{ __html: checkRecord }} ></div>)}

                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-span-12 md:col-span-3"></div>
                                    <div className="col-span-12 md:col-span-6 px-3 wow animate__animated animate__fadeInUp mb-5" data--wow-delay="0.3s" >
                                        <div className="bg-secondary border-t border-secondary text-xs p-5 py-5 rounded-3xl shadow-2xl font-pmedium text-center">

                                            <p className="mb-2"><i className="fa fa-unlock"></i> Upgrade your slots to unlock more earning potentials on MarkMan</p>
                                            <Link to="/slots" className="text-xs small bg-secondary-100 mt-3 text-white py-1 font-p-regular px-3 ml-1 rounded-lg"><i className="fa fa-arrow-up"></i> Check Slots</Link>


                                        </div>
                                    </div>


                                    <div className="col-span-12 md:col-span-3"></div>

                                    <div className="col-span-12 md:col-span-6 lg:col-span-4 text-white  px-3 wow animate__animated animate__fadeInUp mb-5" data--wow-delay="0.5s">
                                        <div className="bg-secondary-200  p-10 py-5 rounded-b-3xl border-t border-secondary shadow-2xl flex items-center justify-center">
                                            <div className="glow-circle rounded-full border-white text-base h-[30px] w-[30px] justify-center flex items-center justify-center">
                                                <i className="fa fa-link text-secondary-100"></i>
                                            </div>

                                            <div className="ml-3">
                                                <h3 className="text-md font-pmedium text-center text-secondary">
                                                    Total Profit
                                                </h3>

                                                <h3 className="text-xl text-gray text-center font-psemibold">
                                                    ${formatEth(userData?.user?.[2])} 
                                                </h3>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-span-12 md:col-span-6 lg:col-span-4 text-white  px-3 wow animate__animated animate__fadeInUp mb-5" data--wow-delay="0.5s">
                                        <div className="bg-secondary-200  p-10 py-5  rounded-b-3xl border-t border-secondary shadow-2xl flex items-center justify-center">
                                            <div className="glow-circle rounded-full border-white text-base h-[30px] w-[30px] justify-center flex items-center justify-center">
                                                <i className="fa fa-users text-secondary-100"></i>
                                            </div>

                                            <div className="ml-3">
                                                <h3 className="text-md font-pmedium text-secondary text-center">
                                                    Partners
                                                </h3>

                                                <h3 className="text-xl text-gray font-psemibold text-center">
                                                    {userData?.refs}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="col-span-12 md:col-span-12 lg:col-span-4 text-white  px-3 wow animate__animated animate__fadeInUp mb-5" data--wow-delay="0.5s">
                                        <div className="bg-secondary-200  p-10 py-5  rounded-b-3xl border-t border-secondary shadow-2xl flex items-center justify-center">
                                            <div className="glow-circle rounded-full border-white text-base h-[30px] w-[30px] justify-center flex items-center justify-center">
                                                <i className="fa fa-users text-secondary-100"></i>
                                            </div>

                                            <div className="ml-3">
                                                <h3 className="text-md font-pmedium text-secondary text-center">
                                                    Total Team
                                                </h3>

                                                <h3 className="text-xl text-gray font-psemibold text-center">
                                                    {userData?.team}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>





                                    
                                    <div className="col-span-12 md:col-span-3"></div>

                                    <div className="col-span-12">
                                        <div className="text-md text-secondary my-5">Income Breakdown</div>
                                    </div>

                                    <div className="col-span-6 lg:col-span-3 text-white  px-3 wow animate__animated animate__fadeInUp mb-5" data--wow-delay="0.5s">
                                        <div className="bg-secondary-200  p-10 py-5 rounded-b-3xl border-t border-secondary shadow-2xl flex items-center justify-center">
                                           

                                            <div className="ml-3">
                                                <h6 className="text-sm font-pmedium text-center text-secondary">
                                                    Direct Income
                                                </h6>

                                                <h3 className="text-xl text-gray text-center font-psemibold">
                                                    ${formatEth(userData?.income?.[0])}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="col-span-6 lg:col-span-3 text-white  px-3 wow animate__animated animate__fadeInUp mb-5" data--wow-delay="0.5s">
                                        <div className="bg-secondary-200  p-10 py-5 rounded-b-3xl border-t border-secondary shadow-2xl flex items-center justify-center">
                                           

                                            <div className="ml-3">
                                                <h6 className="text-sm font-pmedium text-center text-secondary">
                                                    Level Income
                                                </h6>

                                                <h3 className="text-xl text-gray text-center font-psemibold">
                                                    ${formatEth(userData?.income?.[1])}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>




                                    <div className="col-span-6 lg:col-span-3 text-white  px-3 wow animate__animated animate__fadeInUp mb-5" data--wow-delay="0.5s">
                                        <div className="bg-secondary-200  p-10 py-5 rounded-b-3xl border-t border-secondary shadow-2xl flex items-center justify-center">
                                           

                                            <div className="ml-3">
                                                <h6 className="text-sm font-pmedium text-center text-secondary">
                                                    Salary Income
                                                </h6>

                                                <h3 className="text-xl text-gray text-center font-psemibold">
                                                    ${formatEth(userData?.income?.[3])}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>

                                    

                                    <div className="col-span-6 lg:col-span-3 text-white  px-3 wow animate__animated animate__fadeInUp mb-5" data--wow-delay="0.5s">
                                        <div className="bg-secondary-200  p-10 py-5 rounded-b-3xl border-t border-secondary shadow-2xl flex items-center justify-center">
                                           

                                            <div className="ml-3">
                                                <h6 className="text-sm font-pmedium text-center text-secondary">
                                                    Lottery Income
                                                </h6>

                                                <h3 className="text-xl text-gray text-center font-psemibold">
                                                    ${formatEth(userData?.income?.[3])}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>





                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </section>


        </>

    )
}

export default Dashboard;